import "./banner_enterprise.css";
import BannerImg from "../../../../assets/imgs/mockups/enterprise_banner.webp";
import PlayStore from "../../../../assets/icons/library/google-play.webp";
import WebIcon from "../../../../assets/icons/samples/web.svg";
import { WrapperComponent, StoreButton } from "../../../_imports";
import Links from "../../../../constants/links";

function BannerEnterprise() {
    return (
        <section className="banner-enterprise">
            <WrapperComponent>
                <div className="banner-ent-content">
                    <div className="banner-ent-visual">
                        <img
                            src={BannerImg}
                            alt="Painel de controle Tonalida para empresas"
                            fetchPriority="high"
                            width="800"
                            height="800"
                        />
                    </div>
                    <div className="banner-ent-info">
                        <h1 className="banner-ent-title">FECHE SUAS VAGAS ROTATIVAS MAIS RÁPIDO E MAIS BARATO!</h1>
                        <p className="banner-ent-description">
                            Somos a solução de R&S com o melhor custo-benefício do mercado, desenvolvida para agilizar suas contratações de vagas operacionais e rotativas.
                            <br /><br />
                            Esqueça as taxas por contratação. Na Tonalida, você paga apenas pela divulgação da vaga e tem total liberdade para contratar quantos profissionais sua empresa precisar, sem custos surpresa.
                            <br /><br />
                            Nossa tecnologia trabalha por você, a TonIA realiza a primeira entrevista de forma 100% online e automática, entregando candidatos pré-analisados para que você foque apenas na escolha ideal.
                        </p>
                        <div className="banner-ent-actions-wrapper">
                            <p className="download-subtitle">Baixe aqui:</p>
                            <div className="banner-ent-actions">
                                <StoreButton
                                    icon={PlayStore}
                                    storeName="Google Play"
                                    textTop="Disponível na"
                                    url={Links.appEntPlay}
                                    ariaLabel="Baixar aplicativo Tonalida para Empresas na Google Play"
                                />
                                <StoreButton
                                    icon={WebIcon}
                                    storeName="Portal Web"
                                    textTop="Disponível no"
                                    url={Links.portal}
                                    ariaLabel="Acessar Portal Web Tonalida para Empresas"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </WrapperComponent>
        </section>
    );
}

export default BannerEnterprise;
